/** 侧边栏收缩菜单 */
import './index.scss'
import React from 'react';
import {Menu} from 'antd';
import pub from "../../lib/public"
import api from '../../lib/api'
import routes from '../../router/router'
import IconFont from '../IconFont/index';
const {SubMenu} = Menu;

class SliderMenu extends React.Component {
  state = {
    openKeys: [],
    selectKeys: [],
    routers: [],
    routeMap: {}
  };
  onOpenChange = keys => {
    this.setState({
      openKeys: keys.length
        ? [keys[keys.length - 1]]
        : []
    })
  };
  onSelectChange = ({item, key, keyPath, selectedKeys, domEvent}) => {
    this.setState({selectKeys: selectedKeys})
  };
  setMenu(data) {
    return (data.map((menu) => {
      if (menu.child) {
        return (
          <SubMenu
            key={menu.id}
            icon={< IconFont type = {
            menu.icon
          }
          style = {{fontSize: 22}}/>}
            title={menu.title}>
            {this.setMenu(menu.child)}
          </SubMenu>
        )
      } else {
        return (
          <Menu.Item
            key={menu.id}
            icon={< IconFont type = {
            menu.icon || ' '
          }
          style = {{fontSize: 22}}/>}>
            <a href={`#${this.state.routeMap[menu.functionCode]}`}>{menu.title}</a>
          </Menu.Item>
        )
      }
    }))
  }
  setMenuStatus(menu) {
    let _map = {};
    routes.forEach((v, i) => {
      if (v.functionCode)
        _map[v.functionCode] = v.path;
      }
    )
    let urlNow = this.props.routeData.location.pathname;
    let selectId = "";
    let openKeys = "";
    let _menu = menu || this.state.routers;
    for (let i = 0; i < _menu.length; i++) {
      if (urlNow.includes(_map[_menu[i]['functionCode']])) {
        selectId = _menu[i]['id'];
        openKeys = _menu[i]['id'];
        break;
      } else if (_menu[i].child) {
        for (let j = 0; j < _menu[i].child.length; j++) {
          if (urlNow.includes(_map[_menu[i].child[j]['functionCode']])) {
            selectId = _menu[i].child[j]['id'];
            openKeys = _menu[i]['id'];
          }
        }
      }
    }
    this.setState({
      routers: _menu,
      routeMap: _map,
      selectKeys: selectId
        ? [String(selectId)]
        : [],
      openKeys: openKeys
        ? [String(openKeys)]
        : []
    })
  }
  getUserInfo = () => {
    api
      .getUserInfo({})
      .then(res => {
        if (res.status === 200) {
          this.setMenuStatus(res.data.menus);
          this
            .props
            .setName(res.data.user.name);
        }
      })
  };
  UNSAFE_componentWillMount = () => {
    if (window.location.href && window.location.href.includes('SID')) {
      const SID = window
        .location
        .search
        .split('SID=')[1];
      pub.setCookie("SID", SID);
      window.location = window
        .location
        .href
        .replace(window.location.search, '');
    }
    this.getUserInfo();
  };
  componentDidUpdate(prevProps) {
    if (prevProps.routeData.location.pathname !== this.props.routeData.location.pathname) {
      this.setMenuStatus(this.state.routers)
    }
  }
  render() {
    const {openKeys, routers, selectKeys} = this.state;
    return (
      <div
        style={{
        width: this.props.collapsed
          ? 80
          : 220
      }}>
        {routers.length
          ? <Menu
              mode="inline"
              theme="dark"
              style={{
              height: '100vh',
              paddingTop: 60
            }}
              inlineCollapsed={this.props.collapsed}
              selectedKeys={selectKeys}
              openKeys={openKeys}
              onSelect={this.onSelectChange}
              onOpenChange={this.onOpenChange}>
              {this.setMenu(routers)}
            </Menu>
          : ''
}
      </div>
    );
  }
}

export default SliderMenu;
